export default "__VITE_ASSET__CH4qyWX7__"